<script>
// import axios from "axios";
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import axios from "axios";
import { todoMethods, todoComputed } from "@/state/helpers";

import { tableData } from "../dataAdvancedtable";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Información general del negocio",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      checked: true,
      label: "",
      active: 1,
      dataOn: "On",
      dataOff: "Off",

      // ************************************** Link
      tableData: tableData,
      title: "Nuevo Cupón",
      items: [
        {
          text: "Descuentos",
          href: "/Descuentos",
        },
        {
          text: "Nuevo Cupón",
          active: true,
        },
      ],
      statData: [
        {
          icon: "bx bx-copy-alt",
          title: "Orders",
          value: "1,235",
        },
        {
          icon: "bx bx-archive-in",
          title: "Revenue",
          value: "$35, 723",
        },
        {
          icon: "bx bx-purchase-tag-alt",
          title: "Average Price",
          value: "$16.2",
        },
      ],
      tableMunicipalitys: [
        {
          id: "#SK2543",
          total: "Municipio 1",
          status: "Activo",
          index: 1,
        },
        {
          id: "#SK2544",
          total: "Municipio 2",
          status: "Inactivo",
          index: 2,
        },
        {
          id: "#SK2545",
          total: "Municipio 3",
          status: "Activo",
          index: 3,
        },
      ],
      showModal: false,
      isLoading: false,
      fullPage: true,
      canCancel: false,
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      todocurrentPage: 1,
      perPage: 10,
      todoperPage: 10,
      pageOptions: [10, 25, 50, 100],
      todoOptions: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortBy: "age",
      sortDesc: false,
      useSlot: false,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#FFFFFF",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
      earningStatus: true,
      options: [
        "Alaska",
        "Hawaii",
        "California",
        "Nevada",
        "Oregon",
        "Washington",
        "Arizona",
        "Colorado",
        "Idaho",
        "Montana",
        "Nebraska",
        "New Mexico",
        "North Dakota",
        "Utah",
        "Wyoming",
        "Alabama",
        "Arkansas",
        "Illinois",
        "Iowa",
      ],
      objeto: {
        id_negocio: 1,
        id_sucursal: 1,
        id_categoria: 1,
        nombre: "",
        descripcion: "",
        restricciones: "Ejemplo",
        vigencia: "",
      },
    };
  },

  computed: {
    ...todoComputed,
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },

    /**
     * Todo list of records
     */
    todoList() {
      return this.todos.length;
    },
  },

  mounted() {
    this.checked = Boolean(this.active);
    // Podemos reutilizar la función update ya que el código es el mismo.
    this.update();

    this.fetchTodos();
    // Set the initial number of items
    this.totalRows = this.tableData.length;

    this.todoTotalRows = this.todos.length;
  },

  methods: {
    update() {
      this.label = this.checked ? this.dataOn : this.dataOff;
    },
    ...todoMethods,

    handleSubmit() {
      const payload = JSON.stringify(this.objeto);
      console.log(payload);
      axios
        .post("/descuentos", payload)
        .then((res) => {
          const { response = "" } = res.data;
          if (response === true) {
            this.$swal("Registro", "Resgitro creado correctamente", "success");
            this.$router.push("/Descuentos");
          } else {
            console.log(res)
            this.$swal("Alerta", "No se pudo crear", "warning");
          }
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          this.$swal("Error", "Ocurrio un error", "error");
        });
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    todoFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.todoTotalRows = filteredItems.length;
      this.todocurrentPage = 1;
    },

    getColor(estado) {
      if (estado == "Activo") return "red";
      else return "green";
    },

    handleInput(value, data) {
      this.editableDataItems[data.index][data.field.key] = value;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-12">
        <v-card>
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-12">
                <h4 class="card-title">
                  Registro de nuevo descuento
                </h4>
              </div>

              <div class="row mt-4">
                <div class="col-sm-12 col-md-1">
                  <b> <label class="form-check-label">Estado </label> </b>
                </div>
                <div class="col-sm-12 col-md-11">
                  <label class="switch" role="button">
                    <input
                      type="checkbox"
                      :value="active"
                      v-model="checked"
                      @change="update"
                    />
                    <div
                      class="circle"
                      :class="{
                        'circle-on': checked,
                        'circle-off': !checked,
                      }"
                    >
                      <span>{{ label }}</span>
                    </div>
                  </label>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-5">
                  <b><label class="form-check-label">Nombre</label></b>
                  <div class="mb-4">
                    <b-form-input
                      id="input-md"
                      v-model="objeto.nombre"
                      placeholder="AMARANTA"
                    ></b-form-input>
                  </div>
                </div>
                <div class="col-sm-12 col-md-7">
                  <b><label class="form-check-label">Descripción</label> </b>
                  <div class="mb-4">
                    <b-form-input
                      id="input-md"
                      v-model="objeto.descripcion"
                      placeholder="Salón de belleza "
                    ></b-form-input>
                  </div>
                </div>
              </div>
              <v-row>
                <v-col md="3">
                  <b
                    ><label class="form-check-label">
                      Vigencia</label
                    >
                  </b>
                  <div class="mb-4">
                    <b-form-input
                      v-model="objeto.vigencia"
                      id="vigencia"
                      type="date"
                      placeholder="dd/mm/yyyy"
                    ></b-form-input>
                  </div>
                </v-col>
              </v-row>

              <!-- <div class="row mt-4">
                <div class="col-sm-12 col-md-12">
                  <h4 class="card-title">Logo</h4>
                </div>
                <div class="col-sm-12 col-md-2">
                  <b>
                    <label class="form-check-label">Agregar URL de logo </label>
                  </b>
                </div>
                <div class="col-sm-12 col-md-10">
                  <label class="switch" role="button">
                    <input
                      type="checkbox"
                      :value="active"
                      v-model="checked"
                      @change="update"
                    />
                    <div
                      class="circle"
                      :class="{
                        'circle-on': checked,
                        'circle-off': !checked,
                      }"
                    >
                      <span>{{ label }}</span>
                    </div>
                  </label>
                </div>
              </div>

              <div class="row mt-4">
                <div class="col-sm-12 col-md-12">
                  <div class="mb-4">
                    <b-form-input
                      id="input-md"
                      placeholder="http://api.sistemabs.com/Data/business/3_20210906191419.jpg"
                    ></b-form-input>
                  </div>
                </div>
              </div> -->
            </div>

            <v-row>
              <v-col md="12">
                <v-btn
                  color="primary"
                  type="button"
                  v-on:click="handleSubmit()"
                >
                  Guardar
                </v-btn>
                <v-divider class="mx-1" inset vertical></v-divider>
                <router-link to="/Descuentos">
                  <v-btn color="error" type="button" id="inputGroupFileAddon03">
                    Cancelar
                  </v-btn>
                </router-link>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss">
$default: black;
$active: #2dc772;
$inactive: #6c757d;
$text: #9d9d9d;
$text-hover: white;
$size: 0.7rem;
$w: 60px;
$h: 25px;
$circle: $h - 4;
$toggle-dis: $w - $circle - 2;

.switch {
  position: relative;
  display: inline-block;
  width: $w;
  height: $h;
  border-radius: 100px;

  .circle {
    display: flex;
    align-items: center;
    width: 100%;
    height: $h - 1;
    border-radius: 100px;
    background-color: $default;

    & > span {
      font-size: $size;
      color: $text;
      padding-left: $h + -6;
    }

    &::before {
      position: absolute;
      content: "";
      height: $circle;
      width: $circle;
      left: 1px;
      top: 1px;
      border-radius: 100px;
      background-color: white;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }

    &:hover {
      background-color: lighten($default, 20);

      & > span {
        color: $text-hover;
      }
    }
  }

  .circle-on {
    background-color: $active;

    & > span {
      color: white;
    }

    &:hover {
      background-color: white;
      border: 1px $active solid;

      &::before {
        background-color: $active;
      }

      & > span {
        color: $active;
      }
    }
  }

  .circle-off {
    background-color: $inactive;

    & > span {
      color: white;
    }

    &:hover {
      background-color: white;
      border: 1px $inactive solid;

      &::before {
        background-color: $inactive;
      }

      & > span {
        color: $inactive;
      }
    }
  }

  & input {
    display: none;

    &:checked + .circle:before {
      -webkit-transform: translateX($toggle-dis);
      -ms-transform: translateX($toggle-dis);
      transform: translateX($toggle-dis);
    }
  }
}
</style>